import React from 'react';

function Input({
  id,
  name,
  value,
  onChange,
  autoComplete,
  required,
  placeholder,
  spellCheck,
  type,
  label,
  error,
  className,
  autoCapitalize,
  onKeyDown,
  readOnly,
  disabled,
}) {
  return (
    <div
      className={`${className} w-full text-xs tracking-tight space-y-1 dark:text-gray-400`}
    >
      {label && (
        <div className="font-semibold disabled:cursor-not-allowed disabled:opacity-50">
          {label} {required && <span className="text-red-400">*</span>}
        </div>
      )}
      <input
        id={id}
        name={name}
        type={type}
        placeholder={placeholder}
        required={required}
        autoComplete={autoComplete}
        autoCapitalize={autoCapitalize}
        spellCheck={spellCheck}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        readOnly={readOnly}
        disabled={disabled}
        className="placeholder-gray-300 text-gray-900 text-sm rounded-md p-3 w-full appearance-none focus:ring-1 focus:ring-emerald-200 border border-gray-200 focus:border-green-400 outline-none focus:outline-none transition ease-in-out duration-500"
      />
      {error && <div className="text-xs font-light text-red-400">{error}</div>}
    </div>
  );
}

export default Input;
